<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <!-- <router-link
        class="profile-link"
        active-class
        :exact="true"
        :to="{name: 'AddStudentCatchUp'}"
      >
        <v-btn color="#6A158E" dark>+ Add Catchup Session</v-btn>
      </router-link> -->

      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <catchup-table></catchup-table>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import CatchupTable from "../../../components/StudentPanel/catchups/CatchupTable";

export default {
  name: "Catchups",
  components: { CatchupTable, BreadCrumbs },
  data() {
    return {
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>